/*
Dilip 12/21/2022 2692790263 show dash board label changes
Ashraf 12/28/2022 2692790263 show dash board label changes
sai krishna  1/2/2023 2692790263 execution payload changes
kavyareddy 01/06/2023  2692790263 Fixed Field separator default issue
kavyareddy 07/2/2023 2692790263 Fixed notify completion and email issue
Dilip 02/7/2023 2692790263 added required validation for genrate report output
Sohel 02/13/2023 3031450488 Fixed Work Queue Roles dropdown issue
Ravi 02/15/2023 2692790263 pass GenerateWorkQueue in payload
Prakash 02/17/2023 3225736869 Added class for Multiselect Label Component.
Prakash 02/20/2023 3225736869 Added class for Multiselect Label Component.
//suresh peddavoora 03/01/2023 3225736869 new ui changes
//Ravi 04/27/2023 3225736869 implement dynamic field name
Sohel 04/05/2022 2692790263 FIxed Filter Method Validation issue
Prakash 5/05/2023 2692790263 add theming color class name
Ravi 05/12/2022 2692790263  fixed action field render issue
Ravi 05/17/2022 2692790263  Rename separator as Field Seperator
Akhila 06/07/2023 2692790263 Added code and description
Prakash 12/06/2023 2692790263 fixed field for runareport
//Ravi 06/15/2023 2692790263 added valueCode in field Seperator dropdown
Akhila 06/19/2023 2692790263 filter method field by list date changes field TODAY or T
Sohel 06/21/2023 2692790263 Fixed Field Prepopulate issue
Akhila 06/23/2023 2692790263 bug fixed TODAY date issue
Ravi 06/15/2023 2692790263 added show label and placeholder conditionally
Ravi 06/15/2023 2692790263 removed by default initial value folder path and output file name
Ravi 07/18/2023 2692790263 show work Queue Filter field Conditionally
Ravi 07/22/2023 2692790263 fixed validation issue in workQueue name
Sohel 10/16/2023 2698811066 Fixed Date Format issue
*/
import {
  FormControl,
  Select,
  MenuItem,
  Button,
  InputLabel,
  TextField,
  makeStyles,
  Checkbox,
  FormHelperText,
  InputAdornment,
} from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
import React, {useEffect, useState, useContext, useRef} from 'react';
import {Form, Formik} from 'formik';
import {ThemeContext} from './../../../themes/ThemeProvider';
import SearchRuleGroup from '../../FrameWorks/BRE/FormulaRuleGroup/SearchRuleGroup';
import GetAccessMethodFields from './../../FrameWorks/ReportMaster/SearchReportMaster/GetAccessMethodFields';
import {useDispatch, useSelector} from 'react-redux';
import {ArrowBack} from '@material-ui/icons';
import * as yup from 'yup';
import {ErrorSnackbar} from './../../../components/CustomSnackBar/index';
import {
  postRunAReport,
  reportMasterUserName,
  reportMasterRoleName,
  getFieldCode,
  getActions,
  postFieldCode,
} from './../../../redux/reducers/BRE/AddReportMaster';
import {
  fetchFilter,
  getAllWorkqueueNameData,
} from './../../../redux/reducers/ReportMaster';
import {getDropDownData} from './../../../redux/reducers/BRE/AddRecordFormat';
import {FILE_TYPE, FIELD_SEPERATOR, DISPOSITION_CODE} from '../../../constants/Lookup';
import PageLoader from './../../../components/PageLoader';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import DialogBox from '../../../components/DialogBox';
import AddFileName from '../../FrameWorks/Reports/AddReport/StepperComponents/AddFileName';
import BreadCrums from './../../../util/BreadCrum';
import {fetchUserDefinedFields} from '../../../redux/reducers/EventTactics/EventTactics';
import ReportFolderPath from '../../FrameWorks/Reports/AddReport/StepperComponents/ReportFolderPath';

const useStyles = makeStyles((theme) => ({
  goBackBtn: {
    padding: '6px 12px',
    color: '#320469',
    marginBottom: '10px',
  },
}));
const options = [
  {
    key: 'Yes',
    value: 'Y',
  },
  {
    key: 'No',
    value: 'N',
  },
];
const displayHeaderData = [
  {key: 'Y', value: 'Yes'},
  {key: 'N', value: 'No'},
];

const OutTypeoptions = [
  {key: 'Text', value: 'Text'},
  {key: 'CSV', value: 'CSV'},
  {key: 'Excel', value: 'Excel'},
];

const showDashboardOptions = [
  {key: 'N', value: 'No'},
  {key: 'showSplitScreen', value: 'Show Split Screen'},
  {key: 'dontShowSplitScreen', value: 'Don\'t Show Split Screen'},
];

const RunaWorkQueueMaster = ({reportDialogData, setSubmit, nightJobRun, dialogClose}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const [open, setOpen] = useState(false);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const componentClasses = useStyles();
  const {
    isLoading,
    dropDownData,
    clientCodeData,
    accessMethodRunListData,
    promptData,
    userNameData,
    runReportData,
    roleNameData,
    fieldCodeData,
    actionData,
    successMsg,
  } = useSelector(({addReportMaster}) => addReportMaster);
  const {getfilterData} = useSelector(({reportMaster}) => reportMaster);
  const [fieldSubmitted, setSubmitted] = useState(false);
  const formDataRef = useRef();
  const rolesData = roleNameData?.length > 0 ? roleNameData?.map((el) => el.roleName) : [];
  const {dropDownDataReportFormat} = useSelector(({addRecordFormat}) => ({
    dropDownDataReportFormat: addRecordFormat?.dropDownData,
  }));
  const resetPromptDataRef = useRef(false);
  const getObjects = (option, typeCode) => {
    const options =
      dropDownDataReportFormat && dropDownDataReportFormat[typeCode] ?
        dropDownDataReportFormat[typeCode] :
        [];
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item?.valueCode === option.toString() || item.value === option) {
          label = item;
        }
      });
    return label;
  };
  // const getValue = (values) => {
  //   let a = values?.split(" ")?.join("");
  //   if (values?.charAt(0) === "T") {
  //     return a?.replace("T", "cast(now()as date)");
  //   } else {
  //     return values;
  //   }
  // };
  const getValue = (values) => {
    const a = values?.split(' ')?.join('');
    const dateValue = values?.length > 1 ? values?.slice(0, 5) :'';
    if (dateValue?.toUpperCase() === 'TODAY') {
      return a?.replace(dateValue, 'cast(now()as date)');
    } else if (values?.charAt(0)?.toUpperCase() === 'T') {
      return a?.replace(values?.charAt(0), 'cast(now()as date)');
    } else {
      return values;
    }
  };
  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.fieldCode === option || item.key === option || item.value === option) {
          label = item;
        }
      });
    return label;
  };
  const handleClose = () => {
    setOpen(false);
    setFolderPath(false);
  };

  const [folderPath, setFolderPath] = useState(false);

  const {additionalInfoData} = useSelector(({reportMaster}) => reportMaster);
  const {userDefinedWindowData, userDefinedFieldsData} = useSelector(
    ({addEventTactic}) => addEventTactic,
  );
  const [showRuleGroupSearch, setShowRuleGroupSearch] = useState(false);


  const initialVal = {
    GenerateWorkQueue: reportDialogData?.createWorkQueue ? reportDialogData?.createWorkQueue : 'Y',
    WorkQueName: reportDialogData?.workQueueName ?
      reportDialogData?.workQueueName :
      reportDialogData?.reportCode ?
        reportDialogData?.reportCode :
        '',
    genrateReportOutput: reportDialogData?.genrateReportOutput ?
      getObject(reportDialogData?.genrateReportOutput, displayHeaderData) :
      '',
    outputType: '',
    ShowOnlyTheReportTotals: 'N',
    RepeatFieldsForMultRecords: 'N',
    DateStampTheReportRun: 'No',
    DateForStampingDebtor: '',
    WindowToStamp: '',
    FieldToStamp: '',
    runFor: reportDialogData?.accessMethod || '',
    showDashboard: reportDialogData?.showDashboard ? reportDialogData?.showDashboard : 'N',
    showFilter:
      reportDialogData?.showDashboard !== 'N' && reportDialogData?.showFilter ?
        reportDialogData?.showFilter :
        'N',
    roles: reportDialogData?.accessRolesList?.length > 0 ? reportDialogData?.accessRolesList : [],
    user:
      reportDialogData?.accessUsersList?.length > 0 ?
        reportDialogData?.accessUsersList?.map((each) => ({userName: each})) :
        [],
    accessMethod: reportDialogData?.accessMethod ?
      getObject(reportDialogData?.accessMethod, fieldCodeData) :
      '',
    action: reportDialogData?.action ? reportDialogData?.action : '',
    displayHeader: reportDialogData?.displayHeader ?
      getObject(reportDialogData?.displayHeader, displayHeaderData) :
      '',
    notifyCompletion:
      reportDialogData?.notifyCompletionEmails?.length > 0 &&
      typeof reportDialogData?.notifyCompletionEmails === 'object' ?
        reportDialogData?.notifyCompletionEmails?.join(',') :
        '',
    notifyError:
      reportDialogData?.notifyErrorEmails?.length > 0 &&
      typeof reportDialogData?.notifyErrorEmails === 'object' ?
        reportDialogData?.notifyErrorEmails?.join(',') :
        '',
    reportFormat:
      reportDialogData?.fixedLength === 'Y' ?
        getObjects('CSV', FILE_TYPE, dropDownDataReportFormat) :
        reportDialogData?.reportFormat ?
          getObjects(reportDialogData?.reportFormat, FILE_TYPE, dropDownDataReportFormat) :
          '',
    fieldSeparator: reportDialogData?.fieldSeparator ?
      getObjects(reportDialogData?.fieldSeparator, FIELD_SEPERATOR, dropDownDataReportFormat) :
      {valueCode: 'comma', value: ','},
    fixedLength: reportDialogData?.fixedLength,
    outputFileName: getfilterData?.reportOutputFileName ? getfilterData?.reportOutputFileName : '',
    reportpath: getfilterData?.reportfolderPath ? getfilterData?.reportfolderPath : '',
  };
  const [initialValue, setInitialValue] = useState(initialVal);

  useEffect(() => {
    dispatch(reportMasterUserName());
    dispatch(reportMasterRoleName());
    dispatch(getAllWorkqueueNameData());
  }, []);
  // useEffect(() => {
  //   console.log(
  //     getObject(reportDialogData?.displayHeader, displayHeaderData),
  //     reportDialogData?.displayHeader,
  //     displayHeaderData,
  //     "getObject(reportDialogData?.displayHeader, displayHeaderData)"
  //   );
  // }, [reportDialogData]);
  useEffect(() => {
    if (successMsg) {
      dialogClose();
    }
  }, [successMsg]);
  useEffect(() => {
    if (reportDialogData?.reportId) {
      dispatch(fetchFilter(reportDialogData?.reportId));
    }
    dispatch(getDropDownData());
  }, [reportDialogData?.reportId]);
  useEffect(() => {
    let newInitialValues = {
      ...initialValue,
    };
    if (getCurrentAccessMethodFields()?.length > 0) {
      getCurrentAccessMethodFields().forEach((field) => {
        const name = field?.paramName;
        if (
          field.paramType === 'disposition' ||
          field.paramType === 'client' ||
          field.paramType === 'collector'
        ) {
          newInitialValues[name] = [];
        } else {
          newInitialValues[name] = '';
        }
      });
    }
    if (
      Object.keys(runReportData)?.length > 0 &&
      Object.keys(dropDownData).length > 0 &&
      accessMethodRunListData?.length > 0 &&
      runReportData?.accessMethodRequest?.accessMethod
    ) {
      newInitialValues = {...initialValue, ...runReportData};
      if (runReportData?.outputType && runReportData?.outputType.length > 0) {
        newInitialValues['outputType'] = OutTypeoptions.filter(
          (opt) => opt.value === runReportData?.outputType,
        )[0];
      }

      if (runReportData?.accessMethodRequest?.value?.length > 0) {
        if (getCurrentAccessMethodFields()?.length > 0) {
          getCurrentAccessMethodFields()?.forEach((field) => {
            const name = field['paramName'];
            if (field.paramType === 'disposition') {
              newInitialValues[name] =
                getOptions(DISPOSITION_CODE).length > 0 &&
                getOptions(DISPOSITION_CODE)
                  .map((code) => {
                    if (runReportData['accessMethodRequest']['value']?.includes(code.valueCode)) {
                      return code;
                    }
                    return null;
                  })
                  .filter((val) => Boolean(val));
            } else if (field.paramType === 'client') {
              newInitialValues[name] =
                clientCodeData.length > 0 &&
                clientCodeData
                  .map((code) => {
                    if (runReportData['accessMethodRequest']['value']?.includes(code.clientCode)) {
                      return code;
                    }
                    return null;
                  })
                  .filter((val) => Boolean(val));
            } else if (field.paramType === 'collector') {
              newInitialValues[name] = runReportData['accessMethodRequest']['value'];
            }
          });
        }
      }
    }
    (newInitialValues['accessMethod'] = reportDialogData?.accessMethod ?
      getObject(reportDialogData?.accessMethod, fieldCodeData) :
      ''),
    setInitialValue(newInitialValues);
  }, [runReportData, dropDownData, clientCodeData, accessMethodRunListData]);

  function getCurrentAccessMethodFields() {
    if (
      Object.keys(runReportData)?.length > 0 &&
      runReportData?.accessMethodRequest?.accessMethod
    ) {
      return (
        accessMethodRunListData?.length > 0 &&
        accessMethodRunListData.filter(
          (data) => data.valueCode === runReportData?.accessMethodRequest?.accessMethod,
        )[0]?.json
      );
    } else {
      return (
        accessMethodRunListData?.length > 0 &&
        accessMethodRunListData.filter(
          (data) => data.valueCode === reportDialogData?.accessMethod,
        )[0]?.json
      );
    }
  }

  function getOptions(typeCode) {
    let label = [];
    label =
      dropDownDataReportFormat && dropDownDataReportFormat[typeCode] ?
        dropDownDataReportFormat[typeCode] :
        [];

    return label;
  }

  useEffect(() => {
    if (additionalInfoData?.accessMethod) {
      dispatch(
        postFieldCode({
          fieldCode: additionalInfoData?.accessMethod,
          options: additionalInfoData?.action,
        }),
      );
      // setFieldCodeValue({ fieldCode: additionalInfoData?.accessMethod })
    }
  }, [additionalInfoData]);

  function getOptionsRecordFormatDropDown(typeCode) {
    let label = [];
    label =
      dropDownDataReportFormat && dropDownDataReportFormat[typeCode] ?
        dropDownDataReportFormat[typeCode] :
        [];

    return label;
  }
  const [fieldCodeValue, setFieldCodeValue] = useState({});
  const [workQueueError, setWorkQueueError] = useState(false);

  useEffect(() => {
    (fieldCodeValue?.fieldCode || reportDialogData?.accessMethod) &&
      dispatch(
        getActions(
          fieldCodeValue?.fieldCode ? fieldCodeValue?.fieldCode : reportDialogData?.accessMethod,
        ),
      );
  }, [fieldCodeValue?.fieldCode, reportDialogData?.accessMethod]);

  const getArrayData = (selectedAccessMethod, data) => {
    if (selectedAccessMethod === 'DBCOLLECTOR') {
      return data?.collectors && data?.collectors.length > 0 ?
        data.collectors.map((i) => (i.clientCode ? i.clientCode : i)) :
        [];
    } else if (selectedAccessMethod === 'DSDISP') {
      return data?.disposition && data?.disposition.length > 0 ?
        data.disposition.map((i) => {
          return i.valueCode;
        }) :
        [];
    } else if (selectedAccessMethod === 'DBCLNT') {
      return data?.client && data?.client.length > 0 ?
        data.client.map((i) => (i.clientCode ? i.clientCode : i)) :
        [];
    } else if (selectedAccessMethod === 'DSSTAT') {
      return data?.phase && data?.phase.length > 0 ? data.phase.map((i) => i?.valueCode) : [];
    } else {
      return [];
    }
  };

  const onSubmit = (data) => {
    // if (data?.user?.length === 0 && data?.roles?.length === 0 && data?.GenerateWorkQueue === "Y") {
    setWorkQueueError(true);
    // } else {
    setWorkQueueError(false);
    const selectedAccessMethod = data?.accessMethod?.fieldCode;
    const payload = {
      accessMethodRequest: {
        accessMethod: data?.accessMethod?.fieldCode ? data?.accessMethod?.fieldCode : '',
        endDate:
          data?.action === '>' ?
            data?.Date ? // ? getFormattedDate(data?.Date)
              getValue(data?.Date) :
              data?.lastDate :
            data?.lastDate ? // ? getFormattedDate(data?.lastDate)
              getValue(data?.lastDate) :
              '',
        action: data?.action ? data?.action : '',
        startDate:
          data?.action === '<' ?
            data?.Date ? // ? getFormattedDate(data?.Date)
              getValue(data?.Date) :
              data?.startDate :
            data?.startDate ? // ? getFormattedDate(data?.startDate)
              getValue(data?.startDate) :
              '',
        value: ['Is Blank', 'Is Not Blank']?.includes(data?.action) ?
          [] :
          getArrayData(selectedAccessMethod, data),
        repositoryName: data?.repoitoryName ? data?.repoitoryName : '',
        fieldName: data?.fieldsName ? data?.fieldsName?.fieldName : '',
        fromValue:
          data?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
          ['BETWEEN', 'NOT BETWEEN']?.includes(data?.action) &&
          data?.fromValues ?
            data?.fieldsName?.fieldType?.toLowerCase() === 'date' ?
              getValue(data?.fromValues) :
              data?.fromValues :
            '',
        toValue:
          data?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
          ['BETWEEN', 'NOT BETWEEN']?.includes(data?.action) &&
          data?.toValues ?
            data?.fieldsName?.fieldType?.toLowerCase() === 'date' ?
              getValue(data?.toValues) :
              data?.toValues :
            '',
      },
      accessRoles: data?.roles ? data?.roles : [],
      accessUsers: data?.user ? data?.user?.map((each) => each?.userName) : [],
      genrateReportOutput: data?.genrateReportOutput ? data?.genrateReportOutput?.key : '',
      notifyCompletionEmails: data?.notifyCompletion.length ?
        data?.notifyCompletion?.split(',') :
        [],
      notifyErrorEmails: data?.notifyError.length ? data?.notifyError?.split(',') : [],
      showDashboard: data?.showDashboard ? data?.showDashboard : 'N',
      showFilter: data?.showDashboard !== 'N' && data?.showFilter ? data?.showFilter : 'N',
      fieldSeparator: data?.fieldSeparator?.value ? data?.fieldSeparator?.value : '',
      reportFormat: data?.reportFormat?.value ? data?.reportFormat?.value : '',
      displayHeader: data?.displayHeader?.value ?
        data?.displayHeader?.value === 'Yes' ?
          'Y' :
          'N' :
        '',
      listAccessRoles: '',
      reportType: 'WQ',
      outputType: data?.outputType?.value ? data?.outputType?.value : '',
      reportId: reportDialogData.reportId,
      workQueueName: data.GenerateWorkQueue === 'Y' && data?.WorkQueName ? data?.WorkQueName : '',
      genrateWorkQueue: data?.GenerateWorkQueue ? data?.GenerateWorkQueue : '',
      reportOutputFileName: data?.outputFileName ? data?.outputFileName : '',
      reportfolderPath: data?.reportpath ? data?.reportpath : '',
    };
    dispatch(postRunAReport(payload));
    // }
  };

  const validationSchema = yup.object().shape({
    // user: generateWorkQueue === "Y" && yup.mixed().test("letters", "Users is Required ", (value) => {
    //   if (value.length > 0) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }),
    // roles: generateWorkQueue === "Y" && yup.mixed().test("letters", "Roles is Required ", (value) => {
    //   if (value.length > 0) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }),
    notifyCompletion: yup.mixed().test('notifyCompletion', 'Invalid Emails ', (value) => {
      if (value?.length) {
        const modifiedValue = value?.split(',');
        const reqArr =
          modifiedValue && modifiedValue?.length > 0 ?
            modifiedValue?.filter((each) => each?.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) :
            [];
        if (reqArr?.length === modifiedValue?.length) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    }),
    notifyError: yup.mixed().test('notifyCompletion', 'Invalid Emails ', (value) => {
      if (value?.length) {
        const modifiedValue = value?.split(',');
        const reqArr =
          modifiedValue && modifiedValue?.length > 0 ?
            modifiedValue?.filter((each) => each?.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) :
            [];
        if (reqArr?.length === modifiedValue?.length) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    }),
    accessMethod: yup.mixed().test('accessMethod', 'Filter Method is required', (value) => {
      if (!value?.fieldCode) {
        return false;
      } else {
        return true;
      }
    }),
    displayHeader: yup.mixed().test('displayHeader', 'Display Header is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    genrateReportOutput: yup
      .mixed()
      .test('genrateReportOutput', 'Genrate Report Output is required', (value) => {
        if (!value?.value) {
          return false;
        } else {
          return true;
        }
      }),
    reportFormat: yup.mixed().test('reportFormat', 'Report Output Format is required', (value) => {
      if (!value?.valueCode) {
        return false;
      } else {
        return true;
      }
    }),
    // GenerateWorkQueue: yup
    //   .mixed()
    //   .test("GenerateWorkQueue", "Generate Work Queue is required", (value) => {
    //     if (!value) {
    //       return false;
    //     } else {
    //       return true;
    //     }
    //   }),
    fieldSeparator: yup
      .mixed()
      .test('fieldSeparator', 'Field Separator is required', (value, ctx) => {
        if (!value?.value && ctx.parent.reportFormat?.valueCode !== 'E') {
          return false;
        } else {
          return true;
        }
      }),
    WorkQueName: yup.string().when(['GenerateWorkQueue'], {
      is: (GenerateWorkQueue) => {
        return GenerateWorkQueue === 'Y';
      },
      then: yup.string().required('Work Queue Name is required'),
      // .test(
      //   "WorkQueName",
      //   "Work Queue Name already in use",
      //   (value) => !checkWorkQueueNameExist(value)
      // ),
    }),
    client:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBCLNT' &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      yup.array().test('client', 'Client is required', (val) => {
        if (val?.length > 0) {
          return true;
        } else {
          return false;
        }
      }),
    disposition:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DSDISP' &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      yup.array().test('dispo', 'Status is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    phase:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DSSTAT' &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      yup.array().test('phase', 'Phase is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    collectors:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBCOLLECTOR' &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      yup.array().test('collector', 'Collector is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    Date:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBLSTDTE' &&
      ['<', '>'].includes(formDataRef?.current?.values?.action) &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      // yup.date().typeError().nullable().required("Date is required"),
      yup?.mixed().test('Date', 'Values is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    startDate:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBLSTDTE' &&
      ['Between'].includes(formDataRef?.current?.values?.action) &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      // yup.date().typeError().nullable().required("Start date is required"),
      yup.mixed().test('startDate', 'From Values is required', (val) => {
        if (!val) {
          return false;
        } else {
          return true;
        }
      }),
    lastDate:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBLSTDTE' &&
      ['Between'].includes(formDataRef?.current?.values?.action) &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      yup.mixed().test('lastDate', 'To Values is required', (val) => {
        if (!val) {
          return false;
        } else {
          return true;
        }
      }),
    repoitoryName:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      yup.mixed().required('Repository Name is required').nullable(),
    fieldsName:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      yup.mixed().required('Field Name is required').nullable(),
    reportpath: yup
      .mixed()
      .test('reportpath', `Invalid Folder path, Can't contain // and \\`, function(value, context) {
        const regex = /^(?!.*\\|.*\/\/).*$/;
        const {parent} = context;
        if (regex.test(parent?.reportpath)) {
          return true;
        } else {
          return false;
        }
      }),
  });

  useEffect(() => {
    dispatch(getFieldCode());
  }, []);
  return (
    <>
      <Formik
        onSubmit={(values) => onSubmit(values)}
        initialValues={initialVal}
        validationSchema={validationSchema}
        enableReinitialize
        innerRef={formDataRef}
      >
        {(props) => {
          const {
            values,
            setFieldValue,
            handleBlur,
            handleChange,
            errors,
            touched,
            resetForm,
          } = props;

          return (
            <>
              {showRuleGroupSearch ? (
                <>
                  <Button
                    variant="text"
                    className={`"mb-2" ${componentClasses.goBackBtn}`}
                    onClick={() => {
                      setShowRuleGroupSearch(false);
                    }}
                  >
                    <ArrowBack className="mr-2" />
                    Go Back
                  </Button>
                  <SearchRuleGroup />
                </>
              ) : (
                <Form autoComplete="off" noValidate>
                  <div className="global-field-textfields new-standard-textfields">
                    <div className={classes.dialoguecardStyles}>
                      {!nightJobRun && (
                        <div className=" col-md-12 mb-4">
                          <BreadCrums
                            name={'Name'}
                            code={reportDialogData?.reportCode}
                            description={'Description'}
                            descriptionValue={reportDialogData?.reportDescription}
                          />
                          {/* <Typography variant="h4">
                            Workqueue Code: {reportDialogData?.reportCode}
                          </Typography> */}
                        </div>
                      )}
                      <div className={`form-row border-bottom mb-3`}>
                        {/* <div className="form-row mt-3"> */}
                        {/* <div
                          className={`col-sm-6 form-group ${classes.labelName} ${classes.selectdropdown}`}
                        >
                          <TextField
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter Run For`}
                            label="Run For"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="runFor"
                            id="runFor"
                            value={values.runFor}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </div> */}
                        {/* {accessMethodRunListData?.length > 0 && ( */}
                        <div className={`col-sm-6 col-md-4 col-xl-4 form-group`}>
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            name="accessMethod"
                            id="accessMethod"
                            size="small"
                            value={values?.accessMethod}
                            options={fieldCodeData}
                            getOptionDisabled={(option) => option.valueCode === null}
                            getOptionLabel={(option) => {
                              return option && option?.fieldCode ? option?.description : '';
                            }}
                            required
                            onChange={(_, data) => {
                              setSubmitted(false);
                              setFieldCodeValue(data);
                              setFieldValue('accessMethod', data);
                              // setFieldValue("action", "");
                              // data?.fieldCode &&
                              //   dispatch(
                              //     postFieldCode({
                              //       fieldCode: data?.fieldCode,
                              //       options: values?.action,
                              //     })
                              //   );
                              if (['DBCLNT', 'DSSTAT', 'DBCOLLECTOR']?.includes(data.fieldCode)) {
                                setFieldValue('action', 'IN');
                                dispatch(
                                  postFieldCode({
                                    fieldCode: data.fieldCode,
                                    options: 'IN',
                                  }),
                                );
                              } else if (data.fieldCode === 'DBUDWFIELDS') {
                                setFieldValue('action', 'NOT IN');
                                dispatch(
                                  postFieldCode({
                                    fieldCode: data.fieldCode,
                                    options: 'NOT IN',
                                  }),
                                );
                              } else if (['DBLSTDTE', 'DSDISP']?.includes(data.fieldCode)) {
                                setFieldValue('action', 'Is Blank');
                                dispatch(
                                  postFieldCode({
                                    fieldCode: data.fieldCode,
                                    options: 'Is Blank',
                                  }),
                                );
                              }
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  className={` ${classes.labelName}`}
                                  {...params}
                                  variant="outlined"
                                  fullWidth
                                  label="Filter Method"
                                  name="accessMethod"
                                  required
                                  // InputLabelProps={{
                                  //   shrink: true,
                                  // }}
                                  error={Boolean(touched.accessMethod && errors.accessMethod)}
                                  placeholder="Select Filter Method"
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'off',
                                  }}
                                />
                              </div>
                            )}
                          />
                          <FormHelperText style={{color: 'red'}} variant="outlined">
                            {touched?.accessMethod && errors?.accessMethod && errors?.accessMethod}
                          </FormHelperText>
                        </div>
                        {values?.accessMethod?.fieldCode === 'DBUDWFIELDS' && (
                          <>
                            <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3 form-group autocomplete-field">
                              <FormControl margin="dense" variant="outlined" fullWidth>
                                <GuiAutoComplete
                                  classes={{
                                    option: classes.option,
                                  }}
                                  name={'repoitoryName'}
                                  size="small"
                                  onBlur={handleBlur}
                                  value={values?.repoitoryName || ''}
                                  onChange={(e, value) => {
                                    resetPromptDataRef.current = true;
                                    setFieldValue('repoitoryName', value);
                                    setFieldValue('fieldsName', '');
                                    if (values?.accessMethod?.fieldCode) {
                                      dispatch(
                                        postFieldCode({
                                          fieldCode: values?.accessMethod?.fieldCode,
                                          options: 'NOT IN',
                                        }),
                                      );
                                    }
                                    value?.length > 0 ?
                                      dispatch(fetchUserDefinedFields(value)) :
                                      null;
                                  }}
                                  options={userDefinedWindowData}
                                  renderInput={(params) => (
                                    <div className="select-field">
                                      <GuiTextField
                                        className={` ${classes.labelName}`}
                                        {...params}
                                        variant="outlined"
                                        margin="dense"
                                        label={'Repository Name'}
                                        required
                                        error={Boolean(
                                          touched?.repoitoryName && errors?.repoitoryName,
                                        )}
                                        placeholder={'Repository Name'}
                                      />
                                    </div>
                                  )}
                                />
                              </FormControl>
                              <FormHelperText style={{color: 'red'}} variant="outlined">
                                {touched?.repoitoryName &&
                                  errors?.repoitoryName &&
                                  errors?.repoitoryName}
                              </FormHelperText>
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3 form-group autocomplete-field">
                              <FormControl margin="dense" variant="outlined" fullWidth>
                                <GuiAutoComplete
                                  classes={{
                                    option: classes.option,
                                  }}
                                  name={'fieldsName'}
                                  size="small"
                                  onBlur={handleBlur}
                                  value={values?.fieldsName || ''}
                                  onChange={(e, value) => {
                                    setFieldValue('action', 'NOT IN');
                                    resetPromptDataRef.current = true;
                                    if (values?.accessMethod?.fieldCode) {
                                      dispatch(
                                        postFieldCode({
                                          fieldCode: values?.accessMethod?.fieldCode,
                                          options: 'NOT IN',
                                        }),
                                      );
                                    }
                                    setFieldValue('fieldsName', value);
                                  }}
                                  options={userDefinedFieldsData}
                                  getOptionLabel={(option) => {
                                    return option && option?.fieldName ? option.fieldName : '';
                                  }}
                                  renderInput={(params) => (
                                    <div className="select-field">
                                      <GuiTextField
                                        className={` ${classes.labelName}`}
                                        {...params}
                                        variant="outlined"
                                        margin="dense"
                                        required
                                        error={Boolean(touched?.fieldsName && errors?.fieldsName)}
                                        label={'Field Name'}
                                        placeholder={'Enter Field Name'}
                                      />
                                    </div>
                                  )}
                                />
                              </FormControl>
                              <FormHelperText style={{color: 'red'}} variant="outlined">
                                {touched?.fieldsName && errors?.fieldsName && errors?.fieldsName}
                              </FormHelperText>
                            </div>
                          </>
                        )}
                        {values?.accessMethod?.fieldCode !== 'DBACCT' && (
                          <>
                            <div className="col-sm-6 col-md-4 col-lg-4 form-group">
                              <GuiAutoComplete
                                classes={{
                                  option: classes.option,
                                }}
                                name="action"
                                id="action"
                                size="small"
                                value={values?.action}
                                options={actionData}
                                disabled={fieldCodeValue?.fieldCode === 'DBACCT'}
                                getOptionLabel={(option) => {
                                  return option ? option : '';
                                }}
                                required
                                onChange={(_, data) => {
                                  setFieldValue('action', data);
                                  resetPromptDataRef.current = true;
                                  values?.accessMethod?.fieldCode &&
                                    data &&
                                    dispatch(
                                      postFieldCode({
                                        fieldCode: values?.accessMethod?.fieldCode,
                                        options: data,
                                      }),
                                    );
                                }}
                                // InputLabelProps={{
                                //   shrink: true,
                                // }}
                                renderInput={(params) => (
                                  <div className="select-field">
                                    <GuiTextField
                                      margin="dense"
                                      className={` ${classes.labelName}`}
                                      {...params}
                                      variant="outlined"
                                      // InputLabelProps={{
                                      //   shrink: true,
                                      // }}
                                      fullWidth
                                      label="Action"
                                      name="action"
                                      placeholder="Select Action"
                                      inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'off',
                                      }}
                                    />
                                  </div>
                                )}
                              />
                            </div>
                            <div
                              className={`${
                                values?.accessMethod?.fieldCode === 'DBUDWFIELDS' ?
                                  'col-lg-8' :
                                  'col-lg-4'
                              } d-flex`}
                            >
                              <GetAccessMethodFields
                                values={values}
                                formProps={props}
                                reportDialogData={reportDialogData}
                                setFieldValue={setFieldValue}
                                accessMethodFields={promptData}
                                setShowRuleGroupSearch={setShowRuleGroupSearch}
                                fieldCodeValue={fieldCodeValue}
                                additionalInfoData={getfilterData?.accessMethodInfo}
                                renderedFrom={'Run Report'}
                                fieldSubmitted={fieldSubmitted}
                                setSubmitted={setSubmitted}
                              />
                            </div>
                          </>
                        )}
                        {/* // added fields */}
                        <div
                          className={`col-sm-6 col-md-4 col-xl-4 form-group autocomplete-field ${
                            values?.roles?.length > 2 && `autocomplete-checkbox`
                          }`}
                        >
                          <FormControl margin="dense" variant="outlined" fullWidth>
                            <GuiAutoComplete
                              name={'roles'}
                              id={'roles'}
                              className={` ${classes.labelName}`}
                              size="small"
                              limitTags={1}
                              classes={{
                                option: classes.option,
                                listbox: classes.listBox,
                              }}
                              disableCloseOnSelect
                              getOptionSelected={(option, value) => option === value}
                              value={values?.roles?.length > 0 ? values?.roles : []}
                              multiple
                              onChange={(e, value) => {
                                if (value?.length > 0) {
                                  setWorkQueueError(false);
                                }
                                handleChange(e);
                                setFieldValue('roles', value);
                              }}
                              options={rolesData}
                              autoHighlight
                              renderOption={(option, {selected}) => {
                                return (
                                  <React.Fragment>
                                    <>
                                      <Checkbox
                                        icon={icon}
                                        checkedIcon={
                                          <CheckBoxIcon
                                            fontSize="small"
                                            className="selectcheckBox"
                                          />
                                        }
                                        checked={selected}
                                        className={classes.checkBox}
                                      />
                                    </>
                                    {option}
                                  </React.Fragment>
                                );
                              }}
                              getOptionLabel={(option) => {
                                return option;
                              }}
                              renderInput={(params) => (
                                <div className="select-field">
                                  <GuiTextField
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                    touched={touched}
                                    error={touched?.roles && errors?.roles}
                                    // InputLabelProps={{ shrink: true }}
                                    label={'Work Queue Roles'}
                                    placeholder={`Select Work Queue Roles`}
                                    className={`autocomplete-multiselect-label`}
                                    inputProps={{
                                      ...params.inputProps,
                                      autoComplete: 'off', // disable autocomplete and autofill
                                    }}
                                  />
                                </div>
                              )}
                            />
                          </FormControl>
                          <FormHelperText variant="outlined">
                            {touched?.roles && errors?.roles ? errors.roles : ''}
                          </FormHelperText>
                        </div>
                        <div
                          className={`col-sm-6 col-md-4 col-lg-4 form-group autocomplete-field ${
                            values?.user?.length > 2 && `autocomplete-checkbox`
                          }`}
                        >
                          <FormControl margin="dense" variant="outlined" fullWidth>
                            <GuiAutoComplete
                              name={'user'}
                              id={'user'}
                              className={` ${classes.labelName}`}
                              size="small"
                              limitTags={1}
                              classes={{
                                option: classes.option,
                                listbox: classes.listBox,
                              }}
                              disableCloseOnSelect
                              getOptionSelected={(option, value) =>
                                option?.userName === value?.userName
                              }
                              value={values?.user?.length > 0 ? values?.user : []}
                              multiple
                              onChange={(e, value) => {
                                if (value?.length > 0) {
                                  setWorkQueueError(false);
                                }
                                handleChange(e);
                                setFieldValue('user', value);
                              }}
                              options={userNameData}
                              autoHighlight
                              renderOption={(option, {selected}) => {
                                return (
                                  <React.Fragment>
                                    <>
                                      <Checkbox
                                        icon={icon}
                                        checkedIcon={
                                          <CheckBoxIcon
                                            fontSize="small"
                                            className="selectcheckBox"
                                          />
                                        }
                                        checked={selected}
                                        className={classes.checkBox}
                                      />
                                    </>
                                    {option?.userName}
                                  </React.Fragment>
                                );
                              }}
                              getOptionLabel={(option) => {
                                return option?.userName;
                              }}
                              renderInput={(params) => (
                                <div className="select-field">
                                  <GuiTextField
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                    touched={touched}
                                    error={touched?.user && errors?.user}
                                    // InputLabelProps={{ shrink: true }}
                                    label={'Work Queue Users'}
                                    placeholder={`Select Work Queue Users`}
                                    className={`autocomplete-multiselect-label`}
                                    inputProps={{
                                      ...params.inputProps,
                                      autoComplete: 'off', // disable autocomplete and autofill
                                    }}
                                  />
                                </div>
                              )}
                            />
                          </FormControl>
                          <FormHelperText variant="outlined">
                            {touched?.user && errors?.user ? errors.user : ''}
                          </FormHelperText>
                        </div>
                        <div
                          className={`col-sm-6 col-md-4 col-xl-4 form-group ${classes.selectField}`}
                        >
                          <FormControl
                            margin="dense"
                            variant="outlined"
                            fullWidth
                            className={`form-control ${classes.labelName}`}
                            // className="form-control"
                          >
                            <InputLabel id="demo-simple-select-label">
                              Show Work Queue List
                            </InputLabel>
                            <Select
                              fullWidth
                              name="showDashboard"
                              className="select-gender"
                              labelId="demo-simple-select-label"
                              label="Show Work Queue List"
                              value={values.showDashboard || 'N'}
                              onChange={(e) => {
                                setFieldValue('showDashboard', e.target.value);
                              }}
                            >
                              {showDashboardOptions.map((option) => {
                                return (
                                  <MenuItem value={option.key} key={option.key}>
                                    {option.value}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </div>
                        {values?.showDashboard === 'dontShowSplitScreen' && (
                          <div
                            className={`col-sm-6 col-md-4 col-xl-4 form-group ${classes.selectField}`}
                          >
                            <FormControl
                              margin="dense"
                              variant="outlined"
                              fullWidth
                              className={`form-control ${classes.labelName}`}
                              // className="form-control"
                            >
                              <InputLabel id="demo-simple-select-label">
                                Show Work Queue Filter
                              </InputLabel>
                              <Select
                                fullWidth
                                name="showFilter"
                                className="select-gender"
                                label="Show Work Queue Filter"
                                labelId="demo-simple-select-label"
                                value={values.showFilter || 'N'}
                                onChange={(e) => {
                                  setFieldValue('showFilter', e.target.value);
                                }}
                              >
                                {options.map((option) => {
                                  return (
                                    <MenuItem value={option.value} key={option.key}>
                                      {option.key}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </div>
                        )}
                        <div className={`col-sm-6 col-md-4 col-lg-4 form-group`}>
                          <TextField
                            className={`${classes.labelName}`}
                            placeholder="Enter Notify Completion Emails"
                            margin="dense"
                            name="notifyCompletion"
                            variant="outlined"
                            value={values?.notifyCompletion}
                            label="Notify Completion Emails"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            // required
                            onBlur={handleBlur}
                            onChange={(e) => {
                              setFieldValue('notifyCompletion', e.target.value);
                            }}
                            fullWidth
                          />
                          <FormHelperText margin="dense" variant="outlined">
                            {errors.notifyCompletion ? errors.notifyCompletion : ''}
                          </FormHelperText>
                        </div>
                        <div className={`col-sm-6 col-md-4 col-lg-4 form-group`}>
                          <TextField
                            className={`${classes.labelName}`}
                            placeholder="Enter Notify Error Emails"
                            margin="dense"
                            name="notifyError"
                            variant="outlined"
                            value={values?.notifyError}
                            label="Notify Error Emails"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            // required
                            onBlur={handleBlur}
                            onChange={(e) => {
                              setFieldValue('notifyError', e.target.value);
                            }}
                            fullWidth
                          />
                          <FormHelperText margin="dense" variant="outlined">
                            {errors.notifyError ? errors.notifyError : ''}
                          </FormHelperText>
                        </div>

                        <div className={`col-sm-6 col-md-4 col-xl-4 form-group`}>
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            name="genrateReportOutput"
                            id="genrateReportOutput"
                            className={`${classes.labelName}`}
                            size="small"
                            value={values?.genrateReportOutput}
                            autoHighlight
                            options={displayHeaderData}
                            getOptionLabel={(option) => {
                              return option && option?.value ? option?.value : '';
                            }}
                            onChange={(_, data) => {
                              setFieldValue('genrateReportOutput', data);
                            }}
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  // className={`${classes.labelName} ${classes.selectLabel}`}
                                  {...params}
                                  {...params}
                                  variant="outlined"
                                  fullWidth
                                  label="Genrate Report Output"
                                  name="genrateReportOutput"
                                  required
                                  error={Boolean(
                                    touched.genrateReportOutput && errors.genrateReportOutput,
                                  )}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'off',
                                  }}
                                  placeholder="Select GenrateReportOutput"
                                />
                              </div>
                            )}
                          />
                          <FormHelperText variant="outlined">
                            {touched?.genrateReportOutput && errors?.genrateReportOutput ?
                              errors.genrateReportOutput :
                              ''}
                          </FormHelperText>
                        </div>
                        {values?.genrateReportOutput?.key === 'Y' && (
                          <>
                            <div className={`col-sm-6 col-md-4 col-xl-4 form-group py-1`}>
                              <TextField
                                className={` ${classes.labelName}`}
                                margin="dense"
                                variant="outlined"
                                placeholder={`Enter Work Queue name`}
                                label="Work Queue name"
                                // InputLabelProps={{
                                //   shrink: true,
                                // }}
                                name="WorkQueName"
                                required
                                value={values.WorkQueName}
                                error={Boolean(touched.WorkQueName && errors.WorkQueName)}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                fullWidth
                              />
                              <FormHelperText
                                style={{color: 'red', paddingTop: '5px'}}
                                variant="outlined"
                              >
                                {touched.WorkQueName && errors.WorkQueName && errors.WorkQueName}
                              </FormHelperText>
                            </div>
                            <div className={`col-sm-6 col-md-4 col-xl-4 form-group`}>
                              <GuiAutoComplete
                                classes={{
                                  option: classes.option,
                                }}
                                id="fieldSeparator"
                                name="fieldSeparator"
                                className={`${classes.labelName}`}
                                size="small"
                                value={values?.fieldSeparator}
                                autoHighlight
                                options={getOptionsRecordFormatDropDown(
                                  FIELD_SEPERATOR,
                                  dropDownDataReportFormat,
                                )}
                                getOptionLabel={(option) => {
                                  return option && option?.value ? option?.value : '';
                                }}
                                renderOption={(option) => {
                                  return option?.value ?
                                    option?.value + '  ' + `(${option?.valueCode})` :
                                    '';
                                }}
                                onChange={(_, data) => {
                                  setFieldValue('fieldSeparator', data);
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                renderInput={(params) => (
                                  <div className="select-field">
                                    <GuiTextField
                                      // className={`${classes.labelName} ${classes.selectLabel}`}
                                      {...params}
                                      variant="outlined"
                                      fullWidth
                                      required
                                      error={Boolean(
                                        touched.fieldSeparator && errors.fieldSeparator,
                                      )}
                                      // InputLabelProps={{
                                      //   shrink: true,
                                      // }}
                                      inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'off',
                                      }}
                                      label="Field Separator"
                                      name="fieldSeparator"
                                      placeholder="Select Field Separator"
                                    />
                                  </div>
                                )}
                              />
                              <FormHelperText style={{color: 'red'}} variant="outlined">
                                {touched.fieldSeparator &&
                                  errors.fieldSeparator &&
                                  errors.fieldSeparator}
                              </FormHelperText>
                            </div>
                            <div className={`col-sm-6 col-md-4 col-xl-4 form-group`}>
                              <GuiAutoComplete
                                classes={{
                                  option: classes.option,
                                }}
                                name="displayHeader"
                                id="displayHeader"
                                className={`${classes.labelName}`}
                                size="small"
                                value={values?.displayHeader}
                                autoHighlight
                                options={displayHeaderData}
                                getOptionLabel={(option) => {
                                  return option && option?.value ? option?.value : '';
                                }}
                                onChange={(_, data) => {
                                  setFieldValue('displayHeader', data);
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                renderInput={(params) => (
                                  <div className="select-field">
                                    <GuiTextField
                                      // className={`${classes.labelName} ${classes.selectLabel}`}
                                      {...params}
                                      {...params}
                                      variant="outlined"
                                      fullWidth
                                      required
                                      label="Display Header"
                                      name="displayHeader"
                                      error={Boolean(touched.displayHeader && errors.displayHeader)}
                                      // InputLabelProps={{
                                      //   shrink: true,
                                      // }}
                                      inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'off',
                                      }}
                                      placeholder="Select Display Header"
                                    />
                                  </div>
                                )}
                              />
                              <FormHelperText style={{color: 'red'}} variant="outlined">
                                {touched.displayHeader &&
                                  errors.displayHeader &&
                                  errors.displayHeader}
                              </FormHelperText>
                            </div>
                            <div
                              className={`col-sm-6 col-md-4 col-xl-4 form-group py-1 reportout-filed`}
                            >
                              <TextField
                                className={` ${classes.labelName}`}
                                margin="dense"
                                variant="outlined"
                                placeholder={`Enter Work Queue Folder Path`}
                                label={'Work Queue Folder Path'}
                                multiline
                                rows={2}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment
                                      style={{cursor: 'pointer'}}
                                      onClick={() => setFolderPath(true)}
                                      position="start"
                                    >
                                      <AddBoxOutlinedIcon />
                                    </InputAdornment>
                                  ),
                                }}
                                // InputLabelProps={{
                                //   shrink: true,
                                // }}
                                name={'reportpath'}
                                value={values?.reportpath}
                                onChange={(e) => {
                                  setFieldValue('reportpath', e.target.value);
                                }}
                                fullWidth
                                touched={touched.reportpath}
                                error={touched.reportpath && errors.reportpath}
                              />
                              <FormHelperText
                                style={{color: 'red', paddingTop: '5px'}}
                                variant="outlined"
                              >
                                {touched.reportpath && errors.reportpath && errors.reportpath}
                                {''}
                              </FormHelperText>
                            </div>
                            <div className={`col-sm-6 col-md-4 col-xl-4 form-group`}>
                              <GuiAutoComplete
                                classes={{
                                  option: classes.option,
                                }}
                                id="reportFormat"
                                name="reportFormat"
                                className={`${classes.labelName}`}
                                size="small"
                                autoHighlight
                                value={values?.reportFormat}
                                options={getOptions(FILE_TYPE, dropDownDataReportFormat)}
                                getOptionDisabled={(option) => option?.valueCode === 'none'}
                                getOptionLabel={(option) => {
                                  return option && option?.value ?
                                    option?.valueCode === null ?
                                      option?.value :
                                      option?.valueCode + ' - ' + option?.value :
                                    '';
                                }}
                                onChange={(_, data) => {
                                  setFieldValue('reportFormat', data);
                                }}
                                renderInput={(params) => (
                                  <div className="select-field">
                                    <GuiTextField
                                      // className={`${classes.labelName} ${classes.selectLabel}`}
                                      {...params}
                                      {...params}
                                      variant="outlined"
                                      fullWidth
                                      label="Report Output Format"
                                      name="reportFormat"
                                      required
                                      // InputLabelProps={{
                                      //   shrink: true,
                                      // }}
                                      error={Boolean(touched.reportFormat && errors.reportFormat)}
                                      inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'off',
                                      }}
                                      placeholder="Select Report Output Format"
                                    />
                                  </div>
                                )}
                              />
                              <FormHelperText style={{color: 'red'}} variant="outlined">
                                {touched.reportFormat && errors.reportFormat && errors.reportFormat}
                              </FormHelperText>
                            </div>
                            <div
                              className={`col-sm-6 col-md-5 col-lg-4 col-xl-4 form-group py-1 reportout-filed`}
                            >
                              <TextField
                                margin="dense"
                                variant="outlined"
                                className={`${classes.labelName}`}
                                placeholder={`Work Queue Report Output File Name`}
                                label={'Work Queue Output File Name'}
                                multiline
                                rows={2}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment
                                      style={{cursor: 'pointer'}}
                                      onClick={() => setOpen(true)}
                                      position="start"
                                    >
                                      <AddBoxOutlinedIcon />
                                    </InputAdornment>
                                  ),
                                }}
                                // InputLabelProps={{
                                //   shrink: true,
                                // }}
                                name={'outputFileName'}
                                value={values?.outputFileName}
                                onChange={(e) => {
                                  setFieldValue('outputFileName', e.target.value);
                                }}
                                fullWidth
                                touched={touched.outputFileName}
                              />
                            </div>
                          </>
                        )}
                      </div>
                      <DialogBox
                        open={open}
                        dialogClose={handleClose}
                        hideFooter={true}
                        maxWidth={'xl'}
                        title={'Work Queue File Name'}
                      >
                        <AddFileName
                          setFieldValues={setFieldValue}
                          setOpen={setOpen}
                          addValues={values}
                          handleClose={handleClose}
                          workqueue={true}
                        />
                      </DialogBox>
                      <DialogBox
                        open={folderPath}
                        dialogClose={handleClose}
                        hideFooter={true}
                        maxWidth={'xl'}
                        title={'Work Queue Folder Path'}
                      >
                        <ReportFolderPath
                          setFieldValues={setFieldValue}
                          setOpen={setOpen}
                          addValues={values}
                          handleClose={handleClose}
                          folderPath={folderPath}
                          workqueue={true}
                        />
                      </DialogBox>
                      {!nightJobRun && (
                        <div className="row justify-content-center">
                          <Button
                            variant="outlined"
                            className={`reset-btn mr-1 ${classes.buttonRoot}`}
                            onClick={() => {
                              resetForm(initialValue);
                            }}
                          >
                            Reset
                          </Button>
                          <Button
                            variant="outlined"
                            type="submit"
                            className={`search-btn ml-1 ${classes.buttonRoot} `}
                            onClick={() => {
                              setSubmitted(true);
                              if (formDataRef.current.isValid) {
                                setSubmitted(false);
                              }
                            }}
                          >
                            Run
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                </Form>
              )}
            </>
          );
        }}
      </Formik>
      {isLoading && <PageLoader />}
      {workQueueError && <ErrorSnackbar errorMsg={'Select either roles or users'} />}
    </>
  );
};

export default RunaWorkQueueMaster;
